const { useState, useEffect } = wp.element;
const { useBlockProps } = wp.blockEditor;
import { Flex, FlexItem, FlexBlock, Card, CardMedia, __experimentalNumberControl, Button, CardFooter, SelectControl, Icon, __experimentalToggleGroupControl, __experimentalToggleGroupControlOption, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { cancelCircleFilled } from '@wordpress/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ColorSelector from '../../controls/color-select/color-select.js';
import FontAwesomeModal from '../../controls/fontawesome/fontawesome.js';
import { setAttributesResponsive } from '../../block/functions.js';
import './icon.css';

const IconControl = ({ attributes, setAttributes, attributeName, onChangeIconPosition, onChangeIcon }) => {
    const [buttonICon, setButtonIcon] = useState(attributes?.icon?.value ? attributes?.icon?.value : false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const currentDevice = useSelect((select) => {
        let deviceType = select('core/edit-post').__experimentalGetPreviewDeviceType();
        deviceType = deviceType.toLowerCase() === 'desktop' ? '' : `:${deviceType.toLowerCase()}`;
        onChangeIconPosition(attributes?.[`icon${deviceType}`]?.position ? attributes?.[`icon${deviceType}`]?.position : 'before');
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleSelectIcon = (icon) => {
        setAttributes({ icon: { ...attributes?.icon, value: icon } });
        setButtonIcon(icon);
        closeModal();
        onChangeIcon(icon);
    };

    const handRemoveIcon = () => {
        setButtonIcon(false);
        setAttributes({ icon: {} });
        onChangeIcon(false);
    }

    const handChangeIconPosition = (newPosition) => {
        setAttributesResponsive('icon.position', newPosition, device, setAttributes, attributes)
    }

    return (
        <div className='softlite-icon-control'>
            <Card style={{ marginBottom: '25px' }}>
                {buttonICon && (
                    <Button className="softlite-button-remove-icon" icon={<Icon icon={cancelCircleFilled} size={14} />} onClick={() => handRemoveIcon()}></Button>
                )}
                <CardMedia
                    onClick={openModal}
                    style={{ height: '80px', display: 'flex', 'align-items': 'center', 'justify-content': 'center' }}
                >
                    {buttonICon && (
                        <FontAwesomeIcon icon={buttonICon} style={{ width: '20px', height: '20px' }} />
                    )}
                </CardMedia>
                <CardFooter className="softlite-footer-card-upload" onClick={openModal}>Select Icon</CardFooter>
            </Card>

            {isModalOpen && (
                <FontAwesomeModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    onSelectIcon={handleSelectIcon}
                />
            )}
            {buttonICon && (
                <>
                    <ColorSelector
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeName="icon.color"
                    />
                    <div className='softlite-toggle-control-icon'>
                        <__experimentalToggleGroupControl
                            __nextHasNoMarginBottom
                            isBlock
                            value={attributes?.[attributeName + deviceString]?.position ? attributes?.[attributeName + deviceString]?.position : 'before'}
                            label="Icon Position"
                            onChange={(newPosition) => handChangeIconPosition(newPosition)}
                            className='softlite-toggle-control-inline'
                        >
                            <__experimentalToggleGroupControlOption
                                label="After"
                                value="after"
                            />
                            <__experimentalToggleGroupControlOption
                                label="Before"
                                value="before"
                            />
                        </__experimentalToggleGroupControl>
                    </div>
                    <__experimentalNumberControl
                        label="Rotate (DEG)"
                        onChange={(newRotate) => setAttributesResponsive('icon.rotate', newRotate, device, setAttributes, attributes)}
                        value={attributes?.[attributeName + deviceString]?.rotate}
                        className='softlite-number-control-inline rotate'
                        style={{ marginBottom: '10px' }}
                    />
                    <Flex style={{ marginBottom: '10px' }}>
                        <FlexItem>
                            <label>Size</label>
                        </FlexItem>
                        <FlexItem style={{ width: '56%' }}>
                            <__experimentalNumberControl
                                onChange={(newSite) => setAttributesResponsive('icon.size', newSite, device, setAttributes, attributes)}
                                value={attributes?.[attributeName + deviceString]?.size ? attributes?.[attributeName + deviceString]?.size : 20}
                                className='softlite-number-control-inline'
                            />
                        </FlexItem>
                    </Flex>
                    <__experimentalNumberControl
                        label="Spacing"
                        onChange={(newSpacing) => setAttributesResponsive('icon.spacing', newSpacing, device, setAttributes, attributes)}
                        value={attributes?.[attributeName + deviceString]?.spacing}
                        className='softlite-number-control-inline'
                    />
                </>
            )}

        </div>
    );
};
export default IconControl;